"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Share = void 0;
var react_1 = __importStar(require("react"));
var storybook_1 = require("@eyecons/storybook");
var ShareIcon = function (_a) {
    var type = _a.type, icon = _a.icon, label = _a.label, onClick = _a.onClick;
    return react_1.default.createElement(storybook_1.Buttons.Button, { onClick: onClick },
        react_1.default.createElement("div", { className: 'storybook-videos-share-icon' },
            react_1.default.createElement("div", { className: "storybook-videos-share-icon-circle bg-" + icon },
                react_1.default.createElement(storybook_1.Icons.Icon, { className: 'h-8 text-gray-400', name: icon })),
            type === 'default' && react_1.default.createElement(storybook_1.Texts.Small, null, label)));
};
var site_url = process.env.NEXT_PUBLIC_STORYBOOK_SITE_URL;
function activeTab(video, type) {
    if (type === void 0) { type = 'share'; }
    var tabs = {
        share: [
            {
                name: 'link',
                label: 'Link',
                url: site_url + "/videos/" + video.slug,
                type: 'text'
            },
        ],
        embed: [
            {
                name: 'iframe',
                label: 'iFrame',
                url: "<iframe width=\"560\" height=\"315\" src=\"" + site_url + "/videos/" + video.id + "/embed\" frameBorder=\"0\" allow=\"autoplay; encrypted-media\" allowfullscreen></iframe>",
                type: 'textarea'
            },
            {
                name: 'javascript',
                label: 'Javascript',
                url: "<div id=\"eyecons-player-" + video.id + "\"></div>\n\n<script type=\"text/javascript\" src=\"" + site_url + "/static/js/video.min.js?id=" + video.id + "&ref=eyecons-player-" + video.id + "\" async=\"true\"></script>",
                type: 'textarea'
            },
        ],
    };
    if (video.hash) {
        tabs.share.push({
            name: 'public',
            label: 'Privé link',
            url: site_url + "/videos/" + video.hash + "/private"
        });
    }
    return { items: tabs[type], active: tabs[type][0] };
}
var Share = function (_a) {
    var video = _a.video, _b = _a.type, type = _b === void 0 ? 'default' : _b, onClose = _a.onClose;
    var _c = react_1.useState(activeTab(video)), tab = _c[0], setTab = _c[1];
    var ButtonCopy = storybook_1.Hooks.useCopy(tab.active.url, tab.active.type, [tab])[0];
    var popitup = function (url, name) {
        var new_window = window.open(url, name, 'height=640,width=570');
        if (window.focus) {
            new_window.focus();
        }
        return false;
    };
    var openURLWithFallback = function (url, fallbackUrl, target) {
        var ios = !!navigator.userAgent.match(/like Mac OS X/i);
        if (!ios && !target) {
            window.location = url;
        }
        else {
            window.open(url, target);
        }
        if (!fallbackUrl) {
            return;
        }
        // Mobile detection
        var now = Date.now();
        var localAppInstallTimeout = window.setTimeout(function () {
            if (Date.now() - now < 1250) {
                window.open(fallbackUrl);
            }
        }, 1000);
        // Desktop detection
        window.addEventListener('blur', function () {
            window.clearTimeout(localAppInstallTimeout);
        });
    };
    var share = function (type, url) {
        var utmUrl = url + '?utm_medium=share';
        switch (type) {
            case 'facebook':
                popitup('https://www.facebook.com/sharer/sharer.php?u=' + utmUrl, 'Delen op Facebook');
                break;
            case 'twitter':
                popitup('https://twitter.com/intent/tweet?status=' + utmUrl, 'Delen op Twitter');
                break;
            case 'whatsapp':
                url = 'Check deze video op Eyecons.com: ' + url + '?utm_source%3Dwhatsapp%26utm_medium%3Dshare';
                openURLWithFallback("whatsapp://send?text=" + url, "https://wa.me/?text=" + url);
                break;
            case 'copy':
                storybook_1.Helpers.copy(url);
                break;
        }
        if (onClose) {
            onClose();
        }
    };
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: storybook_1.Helpers.classNames('storybook-videos-share', "storybook-videos-share-" + type) },
            react_1.default.createElement(ShareIcon, { icon: 'facebook', label: 'Facebook', type: type, onClick: function () { return share('facebook', tab.active.url); } }),
            react_1.default.createElement(ShareIcon, { icon: 'twitter', label: 'Twitter', type: type, onClick: function () { return share('twitter', tab.active.url); } }),
            react_1.default.createElement(ShareIcon, { icon: 'whatsapp', label: 'Whatsapp', type: type, onClick: function () { return share('whatsapp', tab.active.url); } }),
            type === 'player' && react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(ShareIcon, { icon: 'link', type: type, onClick: function () { return share('copy', tab.active.url); } })),
            type === 'default' && react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(ShareIcon, { icon: 'reply', label: 'Delen', type: type, onClick: function () { return setTab(activeTab(video)); } }),
                react_1.default.createElement(ShareIcon, { icon: 'code', label: 'Invoegen', type: type, onClick: function () { return setTab(activeTab(video, 'embed')); } }))),
        react_1.default.createElement("div", { className: 'text-center' },
            react_1.default.createElement(storybook_1.Menus.Dashboard.Tabs, { activeTab: tab.active.name, setActiveTab: function (active) {
                    setTab(__assign(__assign({}, tab), { active: tab.items.findBy('name', active) }));
                }, items: tab.items })),
        type === 'default' && react_1.default.createElement(ButtonCopy, null));
};
exports.Share = Share;
exports.Share.propTypes = {};
exports.Share.defaultProps = {};
